import {useTranslation} from "react-i18next";
import {Box} from "@mui/material";
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import SwitchCustom from "@ui/switchCustom/SwitchCustom";
import {sx} from './sx'
import {
    IExportMutateContext,
    IExportParamsContext
} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {IChangeExportSidebarSettings} from "@ui/tableCustom/types/table";

interface IProps<T>{
    exportMutate:IExportMutateContext<T>,
    exportParams:IExportParamsContext<T>,
    changeExportSidebarSettings?: IChangeExportSidebarSettings,
    hasExportDataFromAllPage?:boolean,

}
function SideBarChangeExport  <T>({
                                 exportMutate,
                                 exportParams,
                                 changeExportSidebarSettings,
                                 hasExportDataFromAllPage
                             }:IProps<T>)  {

    const {t} = useTranslation()
    const {
        onSelectAllRow,
        onSelectAllColumn,
        onClearAllRow,
        onClearAllColumn,
    } = exportMutate;

    const {exportDataFromAllPage, setExportDataFromAllPage} = exportParams;
    return (

        <Box sx={sx.root}>
            {changeExportSidebarSettings?.hasButtonSelectAllRows !== false &&
                <ButtonCustom
                    variant={'contained'}
                    onClick={onSelectAllRow}
                    label={t('selectAllRows')}
                />}

            {changeExportSidebarSettings?.hasButtonClearAllRows !== false &&
                <ButtonCustom
                    variant={'outlined'}
                    onClick={onClearAllRow}
                    label={t('allClearRows')}
                />}
            {changeExportSidebarSettings?.hasButtonSelectAllColumns !== false &&
                <ButtonCustom
                    variant={'contained'}
                    onClick={onSelectAllColumn}
                    label={t('selectAllColumn')}
                />}

            {changeExportSidebarSettings?.hasButtonClearAllColumns !== false &&
                <ButtonCustom
                    variant={'outlined'}
                    onClick={onClearAllColumn}
                    label={t('allClearColumn')}
                />}


            {hasExportDataFromAllPage && <SwitchCustom
                label={t('exportLabels.exportDataFromAllPage')}
                checked={exportDataFromAllPage}
                onChange={setExportDataFromAllPage}
            />}
        </Box>
    )
};

export default SideBarChangeExport;